import React from 'react';
import { Button } from 'react-bootstrap';
import { confirmAlert } from 'react-confirm-alert';


function performNavigation(history, url, openInNewTab) {
  if (openInNewTab) {
    window.open(url, '_blank');
  } else {
    history.push(url);
  }
}


export function showPrompt({ show, messages, errorMessage, history, url, openInNewTab = false, allowNewTabOption = false }) {
  if (show) {
    const options = {
      customUI: ({ onClose }) => {
        return (
          <div className="react-confirm-alert-body">
            <h1>{messages.leave_page_warning}</h1>
            <p>{errorMessage}</p>
            <div className="react-confirm-alert-button-group" style={{ width: '100%', margin: '0 auto', display: 'flex', justifyContent: 'space-between' }}>
              <Button
                key="ButtonOnClose"
                style={{ margin: '1px', flexGrow: 1 }}
                variant="secondary"
                onClick={onClose}
              >
                {messages.editor.abort}
              </Button>
              <Button
                key="ButtonOnActionSameTab"
                style={{ margin: '1px', flexGrow: 1 }}
                variant="primary"
                onClick={() => {
                  performNavigation(history, url, false);
                  onClose();
                }}
              >
                {messages.leave_page_continue}
              </Button>

              {allowNewTabOption && (
                <Button
                  key="ButtonOnActionNewTab"
                  style={{ margin: '1px', flexGrow: 1 }}
                  variant="success"
                  onClick={() => {
                    performNavigation(history, url, true);
                    onClose();
                  }}
                >
                  {messages.open_in_new_tab || 'Open in new Tab'}
                </Button>
              )}
            </div>
          </div>
        );
      },
      childrenElement: () => <div />,
      closeOnEscape: true,
      closeOnClickOutside: true,
    };
    confirmAlert(options);
  } else {
    performNavigation(history, url, openInNewTab);
  }
}

export default function Prompt(props) {
  showPrompt(props);
  return null;
}
